export type SelectItem = Readonly<{ value: string; label: string }>;

/**
 * Native **`select`** with **`qz-input`** styling.
 *
 * @param options - Element **`id`**, option rows, disabled flag.
 * @returns Populated **`HTMLSelectElement`**.
 */
export function createSelectInput(
  options: Readonly<{
    id: string;
    name?: string;
    items: ReadonlyArray<SelectItem>;
    disabled?: boolean;
  }>,
): HTMLSelectElement {
  const sel = document.createElement("select");
  sel.className = "qz-input qz-input--select";
  sel.id = options.id;
  if (options.name !== undefined) {
    sel.name = options.name;
  }
  if (options.disabled === true) {
    sel.disabled = true;
  }
  for (const item of options.items) {
    const opt = document.createElement("option");
    opt.value = item.value;
    opt.textContent = item.label;
    sel.appendChild(opt);
  }
  return sel;
}
